import { render, staticRenderFns } from "./GroupsReport.vue?vue&type=template&id=54951127"
import script from "./GroupsReport.vue?vue&type=script&lang=js"
export * from "./GroupsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports